import React from "react";
import "./RecContents.css"

class RecContents extends React.Component {
    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the NormalForms component
        this.state =
            {
                contents: this.props.value
            };

        }

        onShaneClick = () =>
        {
            this.props.switcher(1);
        }

        onJohnClick = () =>
        {
            this.props.switcher(2);
        }

        onAnnaClick = () =>
        {
            this.props.switcher(3);
        }

        onSrinathClick = () =>
        {
            this.props.switcher(4);
        }

        onChrisClick = () =>
        {
            this.props.switcher(5);
        }

        onPaulClick = () =>
        {
            this.props.switcher(6);
        }

        onYongjunClick = () =>
        {
            this.props.switcher(7);
        }


    render() {
        return (

            <div className='TlDrContents scroll-div'>

            <p><i>Click on a person's name to read their recommendation.</i></p>
            <p className="Bullet"> ▶      </p>
            <p className="ContentItem" onClick={this.onShaneClick}>Shane Scott</p>
            <br/>
            <p>Shane Scott was a fellow student of mine from the Ga Tech Professional Education
            Full Stack Web Development Program.</p> 

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onJohnClick}>John McSwain III</p>
            <br/>
            <p>John McSwain was my instructor in the Ga Tech Professional Education
            Full Stack Web Development Program.</p> 

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onAnnaClick}>Anna Sedlar</p>
            <br/>
            <p>Anna Sedlar was a teaching assistant in the Ga Tech Professional Education
            Full Stack Web Development Program.</p> 

             <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onSrinathClick}>Srinath Kalavichirattil</p>
            <br/>
            <p> Srinath Kalavichirattil was my supervisor at EchoStar.</p> 

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onChrisClick}>Chris Sheppard</p>
            <br/>
            <p>Chris Sheppard was a coworker of mine at EchoStar.</p> 

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onPaulClick}>Paul Thursby</p>
            <br/>
            <p>Paul Thursby was a coworker of mine at EchoStar.</p> 

            <p className="Bullet"> ▶  </p>
            <p className="ContentItem" onClick={this.onYongjunClick}>Yongjun Geng</p>
            <br/>
            <p>Yongjun Geng was a coworker of mine at Motorola.</p> 
  
            </div>

        )

    }

}

export default RecContents;



// WEBPACK FOOTER //
// ./src/components/Recommendations/RecContents.js